import { SagaIterator } from 'redux-saga'
import { all, takeEvery, delay } from 'redux-saga/effects'

import { HubConnectionState } from '@microsoft/signalr'
import { invokeHubAction } from '../actions'

import { tabeebHubName } from '../services/constants'
import { getHubConnection } from '../providers/SignalRContextProvider'

function* onInvokeHubAction(action: ReturnType<typeof invokeHubAction>): SagaIterator {
  const { method, args = [], hubName = tabeebHubName } = action.payload

  let connection = getHubConnection(hubName)
  let retriesLeft = 5

  while (connection?.state !== HubConnectionState.Connected && retriesLeft > 0) {
    yield delay(1000)

    connection = getHubConnection(hubName)
    retriesLeft--
  }

  if (connection?.state !== HubConnectionState.Connected) {
    return
  }

  // eslint-disable-next-line no-console
  connection.invoke(method, ...args).catch(console.error)
}

export default function* hubCalls() {
  yield all([takeEvery(invokeHubAction, onInvokeHubAction)])
}
